import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { typeLabels } from "@/utils/labels";

interface MovieCardProps {
  item: MediaItem;
  rank?: number;
}

export default function MovieCard({ item, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block"
      title={`${item.title} - ${item.genres.join("/")}`}
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title}（${item.year}）`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-foreground-950/70 to-transparent" />
        <span className="absolute left-2 top-2 flex items-center gap-0.5 rounded-full bg-primary-950/80 px-2 py-0.5 text-xs font-bold text-accent-300 backdrop-blur-sm">
          <i className="ri-star-fill text-accent-400" aria-hidden="true" />
          {item.rating.toFixed(1)}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-6 min-w-6 items-center justify-center rounded-md bg-accent-500 px-1 text-xs font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded bg-background-50/90 px-1.5 py-0.5 text-[11px] font-medium text-foreground-800">
          {typeLabels[item.type]}
        </span>
      </div>
      <h3 className="mt-2 line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
        {item.title}
      </h3>
      <p className="mt-0.5 text-xs text-foreground-400">
        {item.year} · {item.region} · {item.genres.slice(0, 2).join("/")}
      </p>
    </Link>
  );
}